const dealerSupportBrandList = [
  {
    brandIds: ['-3PRTY-'],
    name: '3rd Party'
  },
  {
    brandIds: ['-AGBRA-'],
    name: 'AGI Brazil'
  },
  {
    brandIds: ['-AGBRA-'],
    name: 'AGI Brazil'
  },
  {
    brandIds: ['-MMS01-'],
    name: 'MMS'
  },
  {
    brandIds: ['-VIS01-'],
    name: 'VIS'
  },
  {
    brandIds: ['-AGI01-'],
    name: 'AGI'
  },
  {
    brandIds: ['-AIRLA-'],
    name: 'Airlanco'
  },
  {
    brandIds: ['-FRAME-'],
    name: 'Frame'
  },
  {
    brandIds: ['-GGARD-'],
    name: 'Grain Guard'
  },
  {
    brandIds: ['-KEHON-'],
    name: 'KEHO'
  },
  {
    brandIds: ['-MFS01-'],
    name: 'MFS'
  },
  {
    brandIds: ['-NECO1-'],
    name: 'NECO'
  },
  {
    brandIds: ['-WSTEL-'],
    name: 'Westeel'
  },
  {
    brandIds: ['-SRTRK-'],
    name: 'AGI SureTrack'
  },
  {
    brandIds: ['-CMC01-'],
    name: 'CMC'
  },
  {
    brandIds: ['-COMPA-'],
    name: 'Compass'
  },
  {
    brandIds: [
      '-HUTCH-',
      '3PRCL-HUTCH-',
      'ACCES-HUTCH-',
      'PARTS-HUTCH-',
      'SWPCO-HUTCH-',
      'CHCON-HUTCH-',
      'EBNSW-HUTCH-',
      'UNLOD-HUTCH-',
      'PRTBA-HUTCH-',
      'PRTBC-HUTCH-',
      'PRCCV-HUTCH-',
      'TOWER-HUTCH-'
    ],
    name: 'Hutchinson'
  },
  {
    brandIds: ['-JUNGE-'],
    name: 'Junge'
  },
  {
    brandIds: ['-YARGS-'],
    name: 'Yargus'
  },
  {
    brandIds: ['-MILLT-'],
    name: 'Milltec'
  },
  {
    brandIds: ['-IMPRO-'],
    name: 'Improtech'
  },
  {
    brandIds: ['-BATCO-'],
    name: 'Batco'
  },
  {
    brandIds: ['-BROWN-'],
    name: 'Brownie'
  },
  {
    brandIds: ['-ECLIP-'],
    name: 'Eclipse'
  },
  {
    brandIds: ['-GRNMX-'],
    name: 'Grain Maxx'
  },
  {
    brandIds: ['-HIROL-'],
    name: 'Hi Roller'
  },
  {
    brandIds: ['-HSI01-'],
    name: 'HSI'
  },
  {
    brandIds: ['-MARAT-'],
    name: 'Mayrath'
  },
  {
    brandIds: ['-PTM01-'],
    name: 'PTM'
  },
  {
    brandIds: ['-REM01-'],
    name: 'REM'
  },
  {
    brandIds: ['-SABE1-'],
    name: 'SABE'
  },
  {
    brandIds: ['-SENTL-'],
    name: 'Sentinel'
  },
  {
    brandIds: ['-STORM-'],
    name: 'STORM'
  },
  {
    brandIds: ['-TRMCO-'],
    name: 'Tramco'
  },
  {
    brandIds: ['-TWIST-'],
    name: 'Twister'
  },
  {
    brandIds: ['-UNIRN-'],
    name: 'Union Iron'
  },
  {
    brandIds: ['-WESTF-'],
    name: 'Westfield'
  },
  {
    brandIds: ['-WHERT-'],
    name: 'Wheatheart'
  },
  {
    brandIds: ['-YORK1-'],
    name: 'York'
  },
  {
    brandIds: ['-DANMA-'],
    name: 'Danmare'
  },
  {
    brandIds: ['-AGSOL-'],
    name: 'AGI Solutions'
  },
  {
    brandIds: ['-AGSER-'],
    name: 'AGI Service'
  },
  {
    brandIds: ['-STMOR-'],
    name: 'Stormor'
  }
];

const filterAuthorizedBrands = (userBrands, isAGIUser) => {
  if (isAGIUser) {
    return dealerSupportBrandList;
  }

  const brandSet = new Set();

  userBrands.forEach(id => {
    const brand = dealerSupportBrandList.find(ref => ref.brandIds.includes(id));
    if (brand) brandSet.add(brand);
  });

  if (brandSet.size === 0) {
    return [];
  }
  return Array.from(brandSet);
};

const filterAllBrandByAuthBrands = (allBrands, authBrands) =>
  allBrands.filter(brand => {
    return authBrands.find(b => {
      return b.name.toUpperCase() === brand.Name.toUpperCase();
    });
  });

const hasAuthorizedPartBrands = function(partsBrands) {
  return !(Array.isArray(partsBrands) && partsBrands.length > 0);
};

export {
  dealerSupportBrandList,
  filterAuthorizedBrands,
  filterAllBrandByAuthBrands,
  hasAuthorizedPartBrands
};
